import { AfterViewInit, Component, Directive, OnDestroy } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { ReplaySubject, Subject, Subscription } from 'rxjs';

/**
 * Dies abstrakte Klasse delegiert die Methoden eines anderen ControlValueAccessor and diesen ControlValueAccessor.
 * Durch setTimeout wird sicher gestellt das die alles die Delegierte Komponente gereendert wurde bevor an sie delegiert wird.
 *
 * @author femu
 */
// Seit Angular 10 müssen abstrakte Oberklassen auch mit Metadaten annotiert werden
// https://angular.io/guide/migration-undecorated-classes
@Component({
    template: ''
})
export abstract class AbstractDelegatingControlValueAccessor implements ControlValueAccessor, AfterViewInit, OnDestroy {

    protected delegatedInit$: Subject<() => void> = new ReplaySubject();

    private subscription: Subscription;

    private firstChange: boolean = true;

    abstract getDelegate(): ControlValueAccessor;

    writeValue(value: any) {
        if (this.firstChange === true) {
            this.firstChange = false;

            // ValueAccessor.writeValue is being called twice, first time with a phantom null value
            // https://github.com/angular/angular/issues/14988
            if (value === null) {
                return;
            }
        }

        this.delegatedInit$.next(() => this.getDelegate().writeValue(value));
    }

    registerOnChange(fn: any) {
        this.delegatedInit$.next(() => this.getDelegate().registerOnChange(fn));
    }

    registerOnTouched(fn: any) {
        this.delegatedInit$.next(() => this.getDelegate().registerOnTouched(fn));
    }

    setDisabledState(isDisabled: boolean) {
        this.delegatedInit$.next(() => this.getDelegate().setDisabledState(isDisabled));
    }

    ngAfterViewInit() {
        this.subscription = this.delegatedInit$.subscribe(fn => fn());
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
